import React, {useState, useContext} from 'react';
import {Button} from "../../../../Form/Button/Button";
import {buttonColors} from "../../../../Pickers/InputTheme";
import {I18nReactContext} from "../../../../../contexts/I18nContext";
import {SA_loginAsUserAPI} from "../../../../../Services/SA_api";
import {get} from "lodash";
import './LoginAsUserCell.scss';

/**
 * Button component that allows super admin to login as any user
 * Opens login in new tab with automatic authentication
 *
 * @param {Object} props - Component props
 * @param {Object} props.user - User object with id property
 * @returns {JSX.Element} Login As button
 */
export const LoginAsUserCell = ({user}) => {
    const {i18n} = useContext(I18nReactContext);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleLoginAsUser = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const targetUserId = get(user, 'id');

            if (!targetUserId) {
                setError(i18n.translate('errors.userNotFound'));
                return;
            }

            // Generate login URL
            const {loginUrl} = await SA_loginAsUserAPI({targetUserId});

            // Navigate to login URL in the current tab
            window.location.assign(loginUrl);
        } catch (error) {
            console.error('Failed to login as user:', error);
            setError(get(error, 'message') || i18n.translate('errors.failedToGenerateLoginUrl'));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="LoginAsUserCell">
            <Button
                color={buttonColors.PRIMARY}
                size="small"
                text={i18n.translate('superAdmin.allUsersTable.columns.loginAs')}
                onClick={handleLoginAsUser}
                disabled={isLoading}
                data-testid="login-as-user-button"
            />
            {error && (
                <div className="LoginAsUserCell__error" data-testid="login-as-user-error">
                    {error}
                </div>
            )}
        </div>
    );
};
